// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"5060":"d7155ce511420653","28005":"abf780cea46d2af6","53671":"c6a79955814704f9","61790":"4471fa3a306c29a2","70376":"e39ae6a314ab92a7","84214":"771335c4bc1c09bd","88841":"cc78bf791fc7f777"}[chunkId] + ".css";
};